// extracted by mini-css-extract-plugin
export default {"headerClass":"Overture_headerClass__2rDhm"};